import { translations } from "../../../configs/translations";
import { useStore } from "../../../store/store";
import './VinylsColorMenu.css'
import { ColorBlock } from "../../tuning/tuningInformationCard/blocks/ColorBlock";
import { RGBColor } from "react-color";

interface VinylsColorMenuProps {
    color: RGBColor;
    setColor: (color: RGBColor) => void;
}

export const VinylsColorMenu = ({ color, setColor }: VinylsColorMenuProps) => {
    const language = useStore(state => state.language) as keyof typeof translations;
    const t = translations[language];

    
    return (
        <div className="vinyls-menu-wrapper">
            <div className="vinyls-colors-menu">

                <div className="vinyls-menu-header-container">
                    <p className="vinyls-menu-header-title">{t.choose_color}</p>
                </div>

                <ColorBlock color={color} setColor={setColor}/>
            </div>
        </div>
    )
}